import { FIELDS } from '@/pages/SalesOrders/components/SalesOrderLines/constants';

const defaultFields = [
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
  {
    key: 'Id',
    field: FIELDS.ID,
    title: ' Id',
    label: 'Id',
    sortable: true,
    hidden: true,
    width: 50,
  },
  {
    key: 'PartNumber',
    field: FIELDS.PART_NUMBER,
    title: ' Part Number',
    label: 'PartNumber',
    sortable: true,
    hidden: false,
    locked: true,
    width: 150,
  },
  {
    key: 'SalesOrderId',
    field: FIELDS.SALES_ORDER_ID,
    title: ' Sales Order Id',
    label: 'SalesOrderId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'SODate',
    field: FIELDS.SODATE,
    title: 'Sales Order Date',
    label: 'SODate',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CompanyId',
    field: FIELDS.COMPANY_ID,
    title: ' Company Id',
    label: 'CompanyId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CompanyName',
    field: FIELDS.COMPANY_NAME,
    title: ' Customer',
    label: 'CompanyName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ContactId',
    field: FIELDS.CONTACT_ID,
    title: ' Contact Id',
    label: 'ContactId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'QuoteLineId',
    field: FIELDS.QUOTE_LINE_ID,
    title: ' Quote Line Id',
    label: 'QuoteLineId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'RequirementLineId',
    field: FIELDS.REQUIREMENT_LINE_ID,
    title: ' Requirement Line Id',
    label: 'RequirementLineId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'StatusId',
    field: FIELDS.STATUS_ID,
    title: ' Status Id',
    label: 'StatusId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'StatusName',
    field: FIELDS.STATUS_NAME,
    title: ' Status',
    label: 'StatusName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Quantity',
    field: FIELDS.QUANTITY,
    title: ' Quantity',
    label: 'Quantity',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'QuantityAllocated',
    field: FIELDS.QUANTITY_ALLOCATED,
    title: ' Ready to Ship',
    label: 'QuantityAllocated',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'AllocatedCost',
    field: FIELDS.ALLOCATED_COST,
    title: ' Allocated Cost',
    label: 'AllocatedCost',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'QuantityBackordered',
    field: FIELDS.QUANTITY_BACKORDERED,
    title: ' Backordered',
    label: 'QuantityBackordered',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'QuantityInbound',
    field: FIELDS.QUANTITY_INBOUND,
    title: ' Inbound',
    label: 'QuantityInbound',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'QuantityShipped',
    field: FIELDS.QUANTITY_SHIPPED,
    title: ' Shipped',
    label: 'QuantityShipped',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'QuantityReturned',
    field: FIELDS.QUANTITY_RETURNED,
    title: ' Returned',
    label: 'QuantityReturned',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Cost',
    field: FIELDS.COST,
    title: ' Cost',
    label: 'Cost',
    cell: 'formatAmount',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'TotalCost',
    field: FIELDS.TOTAL_COST,
    title: ' Total Cost',
    label: 'TotalCost',
    cell: 'formatAmount',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Price',
    field: FIELDS.PRICE,
    title: ' Price',
    label: 'Price',
    cell: 'formatAmount',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Total',
    field: FIELDS.TOTAL,
    title: ' Total',
    label: 'Total',
    cell: 'formatCurrency',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ConvertedPrice',
    field: FIELDS.CONVERTED_PRICE,
    title: ' Converted Price',
    label: 'ConvertedPrice',
    cell: 'formatCurrency',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ConvertedTotal',
    field: FIELDS.CONVERTED_TOTAL,
    title: ' Converted Total',
    label: 'ConvertedTotal',
    cell: 'formatCurrency',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Comments',
    field: FIELDS.COMMENTS,
    title: ' Comments',
    label: 'Comments',
    sortable: true,
    hidden: false,
    width: 300,
  },
  {
    key: 'WarrantyId',
    field: FIELDS.WARRANTY_ID,
    title: ' Warranty Id',
    label: 'WarrantyId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'DueDate',
    field: FIELDS.DUE_DATE,
    title: ' Due Date',
    label: 'DueDate',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateCode',
    field: FIELDS.DATE_CODE,
    title: ' Date Code',
    label: 'DateCode',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'LotCode',
    field: FIELDS.LOT_CODE,
    title: ' Lot Code',
    label: 'LotCode',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Revision',
    field: FIELDS.REVISION,
    title: ' Revision',
    label: 'Revision',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'NeedByDate',
    field: FIELDS.NEED_BY_DATE,
    title: ' Need By Date',
    label: 'NeedByDate',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CountryOfOriginId',
    field: FIELDS.COUNTRY_OF_ORIGIN_ID,
    title: ' Country Of Origin Id',
    label: 'CountryOfOriginId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CountryOfOriginName',
    field: FIELDS.COUNTRY_OF_ORIGIN_NAME,
    title: ' Country Of Origin',
    label: 'CountryOfOriginName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ConditionId',
    field: FIELDS.CONDITION_ID,
    title: ' Condition Id',
    label: 'ConditionId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'Condition',
    field: FIELDS.CONDITION,
    title: ' Condition',
    label: 'Condition',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'AvailabilityId',
    field: FIELDS.AVAILABILITY_ID,
    title: ' Availability Id',
    label: 'AvailabilityId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'AvailabilityName',
    field: FIELDS.AVAILABILITY_NAME,
    title: ' Availability',
    label: 'AvailabilityName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'WarrantyName',
    field: FIELDS.WARRANTY_NAME,
    title: ' Warranty Name',
    label: 'WarrantyName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'TestingRequested',
    field: FIELDS.TESTING_REQUESTED,
    title: ' Testing Requested',
    label: 'TestingRequested',
    cell: 'checkMark',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ShippingMethodId',
    field: FIELDS.SHIPPING_METHOD_ID,
    title: ' Shipping Method Id',
    label: 'ShippingMethodId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ShippingProviderId',
    field: FIELDS.SHIPPING_PROVIDER_ID,
    title: ' Shipping Provider Id',
    label: 'ShippingProviderId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ShippingProviderName',
    field: FIELDS.SHIPPING_PROVIDER_NAME,
    title: ' Shipping Provider',
    label: 'ShippingProviderName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ShippingMethodName',
    field: FIELDS.SHIPPING_METHOD_NAME,
    title: ' Shipping Method',
    label: 'ShippingMethodName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PartId',
    field: FIELDS.PART_ID,
    title: ' Part Id',
    label: 'PartId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'InternalPN',
    field: FIELDS.INTERNAL_PN,
    title: ' Internal PN',
    label: 'InternalPN',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CustomerPN',
    field: FIELDS.CUSTOMER_PN,
    title: ' Customer PN',
    label: 'CustomerPN',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'AltNumber',
    field: FIELDS.ALT_NUMBER,
    title: ' Alt Number',
    label: 'AltNumber',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'NSNNumber',
    field: FIELDS.NSNNUMBER,
    title: ' NSNNumber',
    label: 'NSNNumber',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'HarmonizedCode',
    field: FIELDS.HARMONIZED_CODE,
    title: ' Harmonized Code',
    label: 'HarmonizedCode',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ScheduleB',
    field: FIELDS.SCHEDULE_B,
    title: ' Schedule B',
    label: 'ScheduleB',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ECCN',
    field: FIELDS.ECCN,
    title: ' ECCN',
    label: 'ECCN',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SKU',
    field: FIELDS.SKU,
    title: ' SKU',
    label: 'SKU',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ManufacturerId',
    field: FIELDS.MANUFACTURER_ID,
    title: ' Manufacturer Id',
    label: 'ManufacturerId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'MfgName',
    field: FIELDS.MFG_NAME,
    title: ' Mfg',
    label: 'MfgName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InventoryClassId',
    field: FIELDS.INVENTORY_CLASS_ID,
    title: ' Inventory Class Id',
    label: 'InventoryClassId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ClassName',
    field: FIELDS.CLASS_NAME,
    title: ' Class',
    label: 'ClassName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InventoryCategoryId',
    field: FIELDS.INVENTORY_CATEGORY_ID,
    title: ' Inventory Category Id',
    label: 'InventoryCategoryId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CategoryName',
    field: FIELDS.CATEGORY_NAME,
    title: ' Category',
    label: 'CategoryName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Description',
    field: FIELDS.DESCRIPTION,
    title: ' Description',
    label: 'Description',
    sortable: true,
    hidden: false,
    width: 300,
  },
  {
    key: 'UoMId',
    field: FIELDS.UO_MID,
    title: ' Uo MId',
    label: 'UoMId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'UOM',
    field: FIELDS.UOM,
    title: ' UOM',
    label: 'UOM',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PackageId',
    field: FIELDS.PACKAGE_ID,
    title: ' Package Id',
    label: 'PackageId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'Package',
    field: FIELDS.PACKAGE,
    title: ' Package',
    label: 'Package',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PiecePerPkg',
    field: FIELDS.PIECE_PER_PKG,
    title: ' Piece Per Pkg',
    label: 'PiecePerPkg',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PhysPkg',
    field: FIELDS.PHYS_PKG,
    title: ' Phys Pkg',
    label: 'PhysPkg',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PartComments',
    field: FIELDS.PART_COMMENTS,
    title: ' Part Comments',
    label: 'PartComments',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CreatedByUserFullName',
    field: FIELDS.CREATED_BY_USER_FULL_NAME,
    title: ' Created By',
    label: 'CreatedByUserFullName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ModifiedByUserFullname',
    field: FIELDS.MODIFIED_BY_USER_FULLNAME,
    title: ' Modified By',
    label: 'ModifiedByUserFullname',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateCreated',
    field: FIELDS.DATE_CREATED,
    title: ' Date Created',
    label: 'DateCreated',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateModified',
    field: FIELDS.DATE_MODIFIED,
    title: ' Date Modified',
    label: 'DateModified',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Active',
    field: FIELDS.ACTIVE,
    title: ' Active',
    label: 'Active',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CreatedByUserId',
    field: FIELDS.CREATED_BY_USER_ID,
    title: ' Created By User Id',
    label: 'CreatedByUserId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ModifiedByUserId',
    field: FIELDS.MODIFIED_BY_USER_ID,
    title: ' Modified By User Id',
    label: 'ModifiedByUserId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'AccountId',
    field: FIELDS.ACCOUNT_ID,
    title: ' Account Id',
    label: 'AccountId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'LeadFree',
    field: FIELDS.LEAD_FREE,
    title: ' Lead Free',
    label: 'LeadFree',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'TempRating',
    field: FIELDS.TEMP_RATING,
    title: ' Temp Rating',
    label: 'TempRating',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'isService',
    field: FIELDS.IS_SERVICE,
    title: 'Is Service',
    label: 'isService',
    cell: 'checkMark',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
